import { gql } from 'src/generated/gql';

export const GET_ID_VERIFICATION_STATUSES = gql(`
  query GetIdVerificationStatuses {
    staff_idVerificationStatuses {
      value
      label
    }
  }
`);
